import Permissions from '../../models/Permissions'
const Index = () => import(/* webpackChunkName: "competencies" */ './Index.vue')
const Create = () => import(/* webpackChunkName: "competence" */ './Create.vue')

const permissions = [
  Permissions.ROOT
]

const modify = {
  path: 'competencies',
  name: 'Manutenção de Competência',
  component: Index,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const create = {
  path: 'competence',
  name: 'Criação de Competência',
  component: Create,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  modify,
  create
}



// WEBPACK FOOTER //
// ./src/views/competence/index.js